'use strict';

var util = angular.module('gymsystem.util');

util.factory('optionalResource', ['$q', '$http', function($q, $http) {
    var self = {};

    function arrayToMap(a, key) {
        var m = {};
        a.forEach(function(v) {
            if(key) {
                m[v[key]] = v;
            } else {
                m[v] = v;
            }
        });
        return m;
    }

    function getter(key) {
        return function(item) {
            return item[key];
        };
    }

    self.rebookResourceBookings = function(option) {
        //option.bookings;
        //option.resources
        //option.wasBooked
        var bookings = option.bookings;
        var excludeBooking = null;
        if(option.wasBooked) {
            excludeBooking = _.uniq(bookings.map(function(b) {return b.id;}));
        }

        var result = {
            resources: option.resources.map(_.clone),
            rooms: []  // roomId, roomName, bookings, chosenResources, availableResources
        };

        var roomsById = {};
        var resourceById = arrayToMap(result.resources, 'id');
        bookings.forEach(function(b) {
            var id = b.staff_id;
            if(roomsById[id]) {
                roomsById[id].bookings.push(b);
                return;
            }

            roomsById[id] = {
                roomId: id,
                roomName: b.staff.name,
                bookings: [b],
                chosenResources: [],
                availableResources: []
            };

            result.rooms.push(roomsById[id]);
        });

        result.refreshByRoomIdAjax = function(roomId) {
            var originalList = option.resources.map(function(r) {return r.id;});
            if(!originalList.length) {
                roomsById[roomId]._availableResourcesFromServer = [];
                result.refreshByRoomId(roomId);
                return;
            }
            $http.post('/api/resourcebooking/resource/get_available_by_room', {
                bookings: roomsById[roomId].bookings.map(function(b) {return {start: b.start.dateTime(), end: b.end.dateTime()};}),
                original_list: originalList,
                exclude_operation: excludeBooking,
            }).success(function(response) {
                roomsById[roomId]._availableResourcesFromServer = response;
                result.refreshByRoomId(roomId);
            });
        };

        result.refreshByRoomId = function(roomId) {
            if(!roomsById[roomId]._availableResourcesFromServer) {return;}  // data is not loaded yet
            var availableFromServer = arrayToMap(roomsById[roomId]._availableResourcesFromServer);
            var busy = result._getBusyResources(roomId);
            var availableResources = roomsById[roomId].availableResources = [];

            result.resources.forEach(function(r) {
                if(busy[r.id]) {return;}
                if(!availableFromServer[r.id]) {return;}
                availableResources.push(r);
            });        
        };

        result.refresh = function(ajax) {
            var fn = ajax?result.refreshByRoomIdAjax:result.refreshByRoomId;
            result.rooms.forEach(function(room) {
                fn(room.roomId);
            });
        };

        result._getBusyResources = function(roomId) {
            var map = {};
            bookings.forEach(function(b) {
                if(b.staff_id === roomId) {return;}

                if(!map[b.start]) {
                    map[b.start] = {};
                }

                map[b.start][b.staff_id] = true;
            });

            var concurrentRooms = {};
            bookings.forEach(function(b) {
                if(b.staff_id !== roomId) {return;}
                if(!map[b.start]) {return;}

                for(var rid in map[b.start]) {
                    concurrentRooms[rid] = true;
                }
            });

            var busy = {};
            function setBusy(r) {
                busy[r.id] = true;
            }
            for(var rid in concurrentRooms) {
                var room = roomsById[rid];
                if(!room) {continue;}
                room.chosenResources.forEach(setBusy);
            }
            return busy;
        };

        result.loadBookedByRoomId = function(roomId) {
            var deferred = $q.defer();
            var booking = roomsById[roomId].bookings[0];
            $http.post('/api/resourcebooking/resource/get_by_operation', {
                operation_id: booking.id
            }).success(function(response) {
                var result = [];
                response.forEach(function(ra) {
                    var resource = resourceById[ra.resource_id];
                    if(resource) {
                        result.push(resource);
                    }
                });
                deferred.resolve(result);
            }).error(deferred.reject);
            return deferred.promise;
        };

        result.getResult = function() {
            return result.rooms.map(function(room) {
                return {
                    room_id: room.roomId,
                    resources: room.chosenResources.map(function(r) {return r.id;})
                };
            });
        };

        result.refresh(true);

        return result;
    };


    self.getResourcesByBookings = function(bookings, option) {
        option = option || {};
        var deferred = $q.defer();
        $http.post('/api/resourcebooking/resource/get_by_operation', {
            operation_id: bookings.map(getter('id'))
        }).success(function(response) {
            var result = [];
            var chosen = {};

            if(option.excludeStaff) {
                bookings.forEach(function(booking) {
                    chosen[booking.staff_id] = true;
                    chosen[booking.xstaff_id] = true;
                });
            }

            response.forEach(function(r) {
                r.result.map(function(b) {
                    if(chosen[b.resource_id]) {return;}
                    chosen[b.resource_id] = true;
                    result.push(b.resource);
                });
            });
            deferred.resolve(result);
        }).error(deferred.reject);

        return deferred.promise;
    };


    self.getResourcesByBookingsPerRoom = function(bookings, option) {
        option = option || {};
        var deferred = $q.defer();

        var bookings = _.uniq(bookings, function(b) {return b.id;});

        var roomByOperation = {};
        var roomByStaff = {};
        var roomList = [];
        bookings.map(function(booking) {
            var room = roomByStaff[booking.staff_id];
            if(!room) {
                room = {
                    id: booking.staff_id,
                    name: booking.staff.fullname,
                    resources: []
                };
                roomList.push(room);
                roomByStaff[booking.staff_id] = room;
            }
            roomByOperation[booking.id] = room;
        });
        $http.post('/api/resourcebooking/resource/get_by_operation', {
            operation_id: bookings.map(getter('id'))
        }).success(function(response) {
            var chosen = {};

            if(option.excludeStaff) {
                bookings.forEach(function(booking) {
                    chosen[booking.staff_id] = true;
                    chosen[booking.xstaff_id] = true;
                });
            }

            response.forEach(function(r) {
                r.result.map(function(b) {
                    if(chosen[b.resource_id]) {return;}
                    chosen[b.resource_id] = true;
                    roomByOperation[r.operation_id].resources.push(b.resource);
                });
            });
            deferred.resolve(roomList);
        }).error(deferred.reject);

        return deferred.promise;
    };

    return self;
}]);
